import React from 'react';
import {
    TrialRunModalHeaderProps,
    trialRunModalStyles,
} from './trial-run-modal-helper';
import { Box, Typography } from '@mui/material';
import { Button, IconButton } from '@biq/apex-ui';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { themeObject } from 'lib';

export const TrialRunModalHeader = ({
    isResultVisible,
    handleCloseClick,
    handleBackButton,
    trialRunPageHeading,
}: TrialRunModalHeaderProps): React.JSX.Element => {
    return (
        <>
            <Box
                sx={{
                    ...trialRunModalStyles.headerContainer,
                    justifyContent: isResultVisible
                        ? 'space-between'
                        : 'flex-end',
                }}
            >
                {isResultVisible && (
                    <Button
                        size='medium'
                        variant='text'
                        startIcon={
                            <ArrowBackIcon
                                color={themeObject.palette.primary[400]}
                            />
                        }
                        onClick={handleBackButton}
                    >
                        Back
                    </Button>
                )}
                <IconButton
                    buttonType='closeButton'
                    size='small'
                    onClick={handleCloseClick}
                    sx={trialRunModalStyles.closeButtonStyles}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box sx={trialRunModalStyles.bodyContainer}>
                <Typography sx={trialRunModalStyles.headingText}>
                    {isResultVisible ? 'Results' : trialRunPageHeading}
                </Typography>
            </Box>
        </>
    );
};
